import "./StockListTableComponent.scss";
import {ITableColumn} from "../../../../../shared/models/table.model";
import React from "react";
import {IProduct} from "../../../../../shared/models/inventory.model";
import ChipComponent from "../../../../../shared/components/chip/ChipComponent";
import {CommonService} from "../../../../../shared/services";
import TableWrapperV2Component
    from "../../../../../shared/components/table-components/table-wrapper-v2/TableWrapperV2Component";
import {APIConfig} from "../../../../../constants";
import commonService from "../../../../../shared/services/common.service";
interface StockListTableComponentProps {
    filterData: any;
}

const StockListTableComponent = (props: StockListTableComponentProps) => {
    const {filterData} =props;

    // const [products] = useState<any>([]);

    // const handleSelectDeselectAllTypes = useCallback((isChecked: boolean) => {
    //     let updatedTypesList = _.cloneDeep(selectedProducts);
    //     if (isChecked) {
    //         updatedTypesList.push(...products);
    //     } else {
    //         updatedTypesList = [];
    //     }
    //     setSelectedProducts(updatedTypesList);
    // }, [selectedProducts, products]);
    //
    // const handleSelectDeselectType = useCallback((isChecked: boolean, type: any) => {
    //     const updatedTypesList = _.cloneDeep(selectedProducts);
    //     if (isChecked) {
    //         updatedTypesList.push(type);
    //     } else {
    //         const code = type.code;
    //         updatedTypesList.splice(updatedTypesList.findIndex(item => item.code === code), 1);
    //     }
    //     setSelectedProducts(updatedTypesList);
    // }, [selectedProducts]);


    // useEffect(() => {
    //     if (selectedProducts.length > 0) {
    //         if (products.map((type: any) => type.zipcode).every((zipcode: any) => selectedProducts.map((type: any) => type.zipcode).includes(zipcode))) {
    //             setIsSelectAll(true);
    //             setIsIndeterminate(false);
    //         } else {
    //             setIsSelectAll(false);
    //             setIsIndeterminate(true);
    //         }
    //
    //     } else {
    //         setIsIndeterminate(false);
    //         setIsSelectAll(false)
    //     }
    // }, [selectedProducts,products]);


    const columns: ITableColumn[] = [
        // {
        //     id: 'select',
        //     label:
        //         <CheckboxComponent
        //             name={"product_select_all"}
        //             size={"small"}
        //             disableRipple={true}
        //             checked={isSelectAll}
        //             indeterminate={isIndeterminate}
        //             onUpdate={(isChecked: any) => {
        //                 handleSelectDeselectAllTypes(isChecked)
        //             }}
        //         />,
        //     hideInColumnPreferences: true,
        //     isDefaultColumn: true,
        //     fixed: "left",
        //     align: "center",
        //     width: '70',
        //     content: (row: any) => (
        //         <>
        //             <CheckboxComponent
        //                 name={"type_select"}
        //                 size={"small"}
        //                 disableRipple={true}
        //                 checked={selectedProducts.findIndex((type: any) => type.id === row.id) > -1}
        //                 onUpdate={(isChecked: boolean) => {
        //                     handleSelectDeselectType(isChecked, row);
        //                 }}/>
        //         </>
        //     )
        // },
        {
            id:'productId',
            isDefaultColumn: true,
            label:'Product ID'
        },
        {
            id:'barcode',
            isDefaultColumn: true,
            label:'Assigned Barcode'
        },
        {
            id: 'addedAt', label: 'Added Timestamp', isDefaultColumn: true, align: 'center',
            content: (item: IProduct) => (
                <>
                    {
                        item?.createdAt ?
                            <>
                                {commonService.formatDate(item?.createdAt)}
                                &nbsp;|&nbsp;
                                {commonService.formatTime(item?.createdAt)} <br/>
                            </> : <> - </>
                    }
                </>
            )
        },
        {
            id: 'addedBy', label: 'Added by', isDefaultColumn: true, align: 'center',
            content: (item: IProduct) => (
                <>
                    {item?.addedByDetails ? <>{item?.addedByDetails?.firstName} {item?.addedByDetails?.lastName}</> : '-'}
                </>
            )
        },
        {
            id: 'status', label: 'Status', isDefaultColumn: true,
            align:'center',width:'150',
            content: (item: IProduct) => (
                <>
                    <ChipComponent className={`min-width-60 ${item?.status}`}
                                   label={CommonService.capitalizeFirstLetter(item?.status)}
                                   variant={'outlined'}/>
                </>
            )
        },

    ];
    return (
        <div className="table-list-container t-table-inside-details stock-list-component">
            <TableWrapperV2Component
                columns={columns}
                url={APIConfig.GET_STOCK_LIST.URL(filterData?.orderId)}
                method={APIConfig.GET_STOCK_LIST.METHOD}
                extraPayload={filterData}
                />
        </div>
    );

};

export default StockListTableComponent;
